<template>
  <v-footer
    height="88"
    class="justify-center"
  >
    © 2024 — Made by his favorite brother
  </v-footer>
</template>

<script>
  export default {
    name: 'CoreFooter',

    components: {
    },
  }
</script>
